import Vue from 'vue'
import VueRouter from 'vue-router'
import FederalView from '../views/FederalView.vue'
import MapView from '../views/MapView.vue'
import ElectionProbabilityView from '../views/ElectionProbabilityView.vue'
import CanadianElectionForecastView from '../views/CanadianElectionForecastView.vue'
import RidingMapView from '../views/RidingMapView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'FederalView',
    component: FederalView
  },
  {
    path: '/election-probability',
    name: 'ElectionProbabilityView',
    component: ElectionProbabilityView
  },
  {
    path: '/canadian-election-forecast',
    name: 'CanadianElectionForecastView',
    component: CanadianElectionForecastView
  },
  {
    path: '/map',
    name: 'MapView',
    component: MapView
  },
  {
    path: '/riding-map',
    name: 'RidingMapView',
    component: RidingMapView
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
